import { render, staticRenderFns } from "./TimeCurrent.vue?vue&type=template&id=c6bd0844&scoped=true&"
import script from "./TimeCurrent.vue?vue&type=script&lang=js&"
export * from "./TimeCurrent.vue?vue&type=script&lang=js&"
import style0 from "./TimeCurrent.vue?vue&type=style&index=0&id=c6bd0844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bd0844",
  null
  
)

component.options.__file = "TimeCurrent.vue"
export default component.exports